import React, { useContext, useEffect, useState } from "react";
import discountimg from "../../../src/assets/images/Discount-warrantyclaim.svg";
import jclabor from "../../../src/assets/images/Discount-JC labor.svg";
import jcpart from "../../../src/assets/images/Discount-JC Part.svg";
import ticketicon from "../../../src/assets/images/ticketsicon.svg";
import reedem from "../../../src/assets/images/redeempoints.svg";
import green from "../../../src/assets/images/green-checkmark-icon.svg";
import { FilterContext } from "../../context/Filter";
import { axInst } from "../Service/Service";

// Helper functions: round to 2 decimals
const formatInMillions = (num) => {
  if (!num && num !== 0) return "0.0 M";
  return `${(num / 1000000).toFixed(2)} M`;
};

const formatInThousands = (num) => {
  if (!num && num !== 0) return "0.0 K";
  return `${(num / 1000).toFixed(2)} K`;
};

const LoyalPoint = () => {
  const [loyaltyPoints, setLoyaltyPoints] = useState(null);
  const { arn: parArn, childArn } = useContext(FilterContext);

  const getLoyaltyPoints = async (payload) => {
    try {
      const res = await axInst.post(
        `${process.env.REACT_APP_API_URL}allLoyaltyPointAnalysis`,
        payload
      );
      return res.data?.result || {};
    } catch (error) {
      console.error("Error fetching loyalty points:", error);
      return {};
    }
  };

  useEffect(() => {
    const fetchPoints = async () => {
      let payload = {};
      if (childArn) payload = { childArn };
      else if (parArn) payload = { parArn };
      else return;

      const points = await getLoyaltyPoints(payload);
      setLoyaltyPoints(points);
    };

    fetchPoints();
  }, [parArn, childArn]);

  return (
    <div className="flex justify-center md:flex m-6 gap-4">
      {/* Accrued and Redeemed */}
      <div className="flex flex-col gap-2">
        {/* Accrued Card */}
        <div className="w-52 h-24 flex gap-4 p-3 border bg-[#E0F7E9] rounded-md items-center">
          <img src={ticketicon} alt="Ticket Icon" />
          <div>
            <h1 className="text-xs font-semibold">Accrued</h1>
            <h1 className="text-sm text-[#233D91] font-bold mt-1">
              {formatInThousands(loyaltyPoints?.accrualedValue)}
            </h1>
          </div>
        </div>

        {/* Redeemed Card */}
        <div className="w-52 h-21 flex gap-4 p-3 border bg-[#E0F7E9] rounded-md items-center">
          <img src={reedem} alt="Redeem Icon" />
          <div>
            <h1 className="text-xs font-semibold">Redeemed</h1>
            <h1 className="text-sm font-bold text-[#233D91] mt-1">
              {formatInThousands(loyaltyPoints?.redeemedValue)}
            </h1>

          </div>
        </div>
      </div>

      {/* Balance Points */}
      <div className="bg-[#E0F7E9] flex justify-center items-center  rounded-md">
        <div className="flex w-36 justify-center rounded-lg">
          <div className="flex-col justify-center items-center text-center">
            <h1 className="text-xs font-semibold mb-1">Balance</h1>
            <h1 className="text-lg font-bold text-[#233D91] mb-2">
              {formatInThousands(loyaltyPoints?.loyaltyPoints)}
            </h1>
            <img className="mt-2 mx-auto" src={green} alt="Green Checkmark" />
          </div>
        </div>
      </div>
    </div >
  );
};

export default LoyalPoint;
